import { PrimeIcons } from "@primevue/core/api";
import { ApiService } from "./api.service";
import { AppIcons } from "../constants/app-icons";
export default class CustomersService extends ApiService {
  namespace = "customer";
  template = "defaultTemplate";
  icon = "GroupOfPeople";
  DOMAIN = 34;
  Width = 1200;
  relations =
    "?expand=rates,rates.itemName,scheduledInvoices,scheduledInvoices.lines,scheduledInvoices.schedules,invoiceCustomerRates";
  search = true;
  data = [];
  name = "Customer";
  action = "action";
  singular = this.terminology.customer.singular;
  plural = this.terminology.customer.plural;
  vowel = this.terminology.customer.vowel;
  gemItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.name }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: this.t("emailEntity", { entity: this.name }),
      icon: AppIcons.MAIL,
    },
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.name }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "report",
      label: this.t("generateReport"),
      icon: AppIcons.DOCUMENT,
    },
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.name }),
      icon: AppIcons.PLUS,
    },
    {
      key: "statement",
      label: this.t("prepare") + " Customer " + this.t("statement", 1),
      icon: AppIcons.DOCUMENT,
    },
  ];

  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.PENCIL,
      field: "display_name",
    },
    {
      header: this.t("number"),
      icon: AppIcons.BARCODE,
      field: "account_number",
    },
    {
      header: this.t("contact"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "contact",
    },
    {
      header: this.t("primaryPhone"),
      icon: AppIcons.MOBILE_PHONE,
      field: "primary_number",
    },
    {
      header: this.t("since"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "since",
    },
    {
      header: this.t("balance"),
      icon: AppIcons.MONEY,
      field: "balance",
    },
  ];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: this.t("editAnEntity", { entity: this.name }),
        icon: AppIcons.EDIT,
      },
      {
        key: "announce",
        label: "announceThisEntity",
        services: -3,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: "emailThisEntity",
        icon: AppIcons.MAIL,
        services: 208,
      },
      {
        key: "bookmark",
        label: "bookmarkThisEntity",
        icon: AppIcons.BOOKMARK,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),

      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  filterItems = [
    { name: "Folders", value: "3", realm: "1" },
    { name: "Type", value: "2", realm: "2" },
    { name: "Categoris", value: "1", realm: "3" },
  ];
  constructor() {
    super("customers");
  }
}
